<div bsModal #viewAllManagersModal="bs-modal" class="modal fade"
     tabindex="-1"
     role="dialog"
     aria-labelledby="viewAllManagersModal"
     aria-hidden="true"
     [config]="{backdrop: 'static', keyboard: false}">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <form *ngIf="active" #viewAllManagersForm="ngForm" novalidate (ngSubmit)="onSubmit()" autocomplete="off">
                <div class="modal-header">
                    <h4 class="modal-title">
                        {{"Axilla.Webshop.FieldAgent.Customer.SelectManager" | localize}}
                    </h4>
                    <button type="button" class="close" (click)="close()" aria-label="Close" [disabled]="saving">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="customer-users-container" >
                        <ng-container *ngFor="let user of customerUsersValue">
                            <p-chip (click)="selectManager(user)" label="{{user | fullName}}" [ngClass]="{'selected-manager': user.id === selectedManager?.id}" ></p-chip>
                        </ng-container>
                    </div>
                </div>
                <div class="modal-footer">
                    <button [disabled]="saving" type="button" class="btn btn-default" (click)="close()">
                        {{"Cancel" | localize}}
                    </button>
                </div>
            </form>
        </div>
    </div>

</div>
